import React, { useState } from 'react';
import axios from 'axios';
import './PauseFollowUps.css';

const PauseFollowUps = () => {
  const axiosDomain = process.env.REACT_APP_AXIOS_DOMAIN;
  const [searchString, setSearchString] = useState('');
  const [error, setError] = useState('');
  const [statusMessage, setStatusMessage] = useState('');
  const [loadingStatus, setLoadingStatus] = useState(false);
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [statusData, setStatusData] = useState(null); // stores { email, status, followup_due, message }

  // First step: Check the current status for the user.
  const handleCheckStatus = async () => {
    setError('');
    setStatusMessage('');
    setStatusData(null);

    if (!searchString.trim()) {
      setError('Please enter an email or case ID.');
      return;
    }

    setLoadingStatus(true);
    try {
      const response = await axios.post(
        `${axiosDomain}/api/followups-status`,
        { searchString },
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('utltoken')}` } }
      );
      setStatusData(response.data);
      setStatusMessage(response.data.message);
    } catch (err) {
      if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        setError('An error occurred while checking follow-up status. Please try again later.');
      }
    } finally {
      setLoadingStatus(false);
    }
  };

  // Second step: Update the status (pause or resume) based on the current status.
  const handleUpdate = async () => {
    if (!statusData) return;
    setError('');
    setStatusMessage('');
    setLoadingUpdate(true);

    // Decide action based on current status: when active, allow pausing; when paused, allow resuming.
    let action = '';
    if (statusData.status === 'active') {
      action = 'pause';
    } else if (statusData.status === 'paused') {
      action = 'resume';
    } else {
      setLoadingUpdate(false);
      return;
    }

    try {
      const response = await axios.post(
        `${axiosDomain}/api/update-followups`,
        { searchString, action },
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('utltoken')}` } }
      );
      setStatusMessage(response.data.message);
      // Optionally refresh the current status.
      const updatedStatus = await axios.post(
        `${axiosDomain}/api/followups-status`,
        { searchString },
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('utltoken')}` } }
      );
      setStatusData(updatedStatus.data);
    } catch (err) {
      if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        setError('An error occurred while updating follow-ups. Please try again later.');
      }
    } finally {
      setLoadingUpdate(false);
    }
  };

  return (
    <div className="pause-container">
      <div className="pause-form">
        <div className="pause-header">
          <h2>Check Follow Up Status</h2>
        </div>

        <div className="form-group-pause">
          <label htmlFor="searchString">Enter Email or Case ID</label>
          <input
            type="text"
            id="searchString"
            name="searchString"
            value={searchString}
            onChange={(e) => setSearchString(e.target.value)}
            placeholder="Email or Case ID"
          />
        </div>

        <button
          className="pause-button"
          onClick={handleCheckStatus}
          disabled={loadingStatus || loadingUpdate}
        >
          {loadingStatus ? 'Checking...' : 'Check Status'}
        </button>

        {/* Only show the update button if we have valid status data and the chaser cycle is not complete */}
        {statusData && statusData.status !== 'complete' && (
          <button
            className="pause-button"
            onClick={handleUpdate}
            disabled={loadingUpdate}
            style={{ marginTop: '10px' }}
          >
            {loadingUpdate
              ? (statusData.status === 'active' ? 'Pausing...' : 'Resuming...')
              : (statusData.status === 'active' ? 'Pause Follow Ups' : 'Resume Follow Ups')}
          </button>
        )}

        {error && <p className="error-message">{error}</p>}
        {statusMessage && <p className="status-message">{statusMessage}</p>}
      </div>
    </div>
  );
};

export default PauseFollowUps;
